/* Component to display a generic error on the invitation flow */
import { useTranslation } from 'react-i18next';
import styled from '@emotion/styled';

import { tokens, Icon, Text, Button } from '@hotjar/hotsauce';
import { useHelpHotjarUrl } from '@hotjar/translations';
import { useTrack } from '@hotjar/webapp/hooks/useTrack';

const SUPPORT_LINK = '/requests/new?ticket_form_id=1500000552002';

const Container = styled.div`
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
`;

const IconContainer = styled.div``;
const Footer = styled.div``;
const Title = styled.div`
  padding-top: ${tokens.spacer.x3};
`;

const Content = styled.div``;

export const SsoInvitationGenericError = (): JSX.Element => {
  const { t } = useTranslation();
  const helpHotjarUrl = useHelpHotjarUrl();
  const { click } = useTrack();

  const handleContactSupport = () => {
    click('Sso Error', 'jointeam', {
      url_event_was_triggered_on: '/jointeam',
    });
    window.open(`${helpHotjarUrl}${SUPPORT_LINK}`, '_blank', 'noopener noreferrer');
  };

  return (
    <Container>
      <IconContainer>
        <Icon color="text_default" icon="warning" size="xl" />
      </IconContainer>
      <Title>
        <Text as="h4" textColor="text_default" textType="header4">
          {t('activation:saml-sso.errors.error-code-generic.title')}
        </Text>
      </Title>
      <Content>
        <Text as="p" textColor="text_light" textType="body1">
          {t('activation:saml-sso.errors.error-code-generic.description')}
        </Text>
      </Content>
      <Footer>
        <Button onClick={handleContactSupport} data-testid="sso-error-contact-support">
          {t('activation:saml-sso.contact-support')}
        </Button>
      </Footer>
    </Container>
  );
};
